import { render, staticRenderFns } from "./NivelServico.vue?vue&type=template&id=068d9c63&scoped=true"
import script from "./NivelServico.vue?vue&type=script&lang=js"
export * from "./NivelServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068d9c63",
  null
  
)

export default component.exports